// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CountrySelect-module__root__tfXSX .mantine-InputBase-input {
  cursor: pointer;
  font-size: var(--mantine-font-size-sm);
}

.CountrySelect-module__root__tfXSX .mantine-InputBase-section[data-position="left"] {
  width: 2.5rem;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.CountrySelect-module__input__DMcMa[data-with-left-section] {
  padding-left: 2.5rem;
}

.CountrySelect-module__placeholder__zuTa_ {
  color: var(--mantine-color-placeholder);
}

.CountrySelect-module__selectedValue___00tq {
  margin-left: 0.25rem;
}

.CountrySelect-module__optionLabel__LhgwM {
  font-size: var(--mantine-font-size-sm);
}

.CountrySelect-module__dropdown__GYq0Z .mantine-Combobox-search {
  padding: var(--mantine-spacing-xs);
}

.CountrySelect-module__dropdown__GYq0Z .mantine-Combobox-search input {
  border: 1px solid var(--mantine-color-gray-3);
  border-radius: var(--mantine-radius-sm);
  font-size: var(--mantine-font-size-sm);
}

.CountrySelect-module__dropdown__GYq0Z .mantine-Combobox-search input:focus {
  border-color: var(--mantine-color-dark-5);
}

.CountrySelect-module__dropdown__GYq0Z .mantine-Combobox-option {
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
}

.CountrySelect-module__dropdown__GYq0Z .mantine-Combobox-option[data-combobox-selected] {
  background-color: var(--mantine-primary-color-light);
}

.CountrySelect-module__dropdown__GYq0Z .mantine-Combobox-option[data-combobox-active] {
  background-color: var(--mantine-color-gray-1);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/form/CountrySelect/CountrySelect.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".root :global(.mantine-InputBase-input) {\n  cursor: pointer;\n  font-size: var(--mantine-font-size-sm);\n}\n\n.root :global(.mantine-InputBase-section[data-position=\"left\"]) {\n  width: 2.5rem;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.input[data-with-left-section] {\n  padding-left: 2.5rem;\n}\n\n.placeholder {\n  color: var(--mantine-color-placeholder);\n}\n\n.selectedValue {\n  margin-left: 0.25rem;\n}\n\n.optionLabel {\n  font-size: var(--mantine-font-size-sm);\n}\n\n.dropdown :global(.mantine-Combobox-search) {\n  padding: var(--mantine-spacing-xs);\n}\n\n.dropdown :global(.mantine-Combobox-search input) {\n  border: 1px solid var(--mantine-color-gray-3);\n  border-radius: var(--mantine-radius-sm);\n  font-size: var(--mantine-font-size-sm);\n}\n\n.dropdown :global(.mantine-Combobox-search input:focus) {\n  border-color: var(--mantine-color-dark-5);\n}\n\n.dropdown :global(.mantine-Combobox-option) {\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n}\n\n.dropdown :global(.mantine-Combobox-option[data-combobox-selected]) {\n  background-color: var(--mantine-primary-color-light);\n}\n\n.dropdown :global(.mantine-Combobox-option[data-combobox-active]) {\n  background-color: var(--mantine-color-gray-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CountrySelect-module__root__tfXSX`,
	"input": `CountrySelect-module__input__DMcMa`,
	"placeholder": `CountrySelect-module__placeholder__zuTa_`,
	"selectedValue": `CountrySelect-module__selectedValue___00tq`,
	"optionLabel": `CountrySelect-module__optionLabel__LhgwM`,
	"dropdown": `CountrySelect-module__dropdown__GYq0Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
